const ITEMS = [
  "NO JUDGMENT",
  "SUSTAINABLE RESULTS",
  "CONFIDENCE",
  "MOBILITY",
  "STRONG FOR LIFE",
  "COMMUNITY",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`font-display font-black uppercase tracking-tight text-5xl sm:text-7xl px-6 ${
            i % 2 === 0 ? "text-sand" : "text-outline-sand"
          }`}
        >
          {item}
        </span>
        <span className="text-brand text-3xl sm:text-4xl" aria-hidden="true">
          •
        </span>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section
    className="relative bg-charcoal py-10 overflow-hidden grain"
    aria-label="Brand values marquee"
    data-testid="values-marquee"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </section>
);

export default Marquee;
